/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ui_Media_Video_LabelInputs */

const en_us2_ui_media_video_label = /** @type {(inputs: Ui_Media_Video_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}, exercise video`)
};

const pt_br2_ui_media_video_label = /** @type {(inputs: Ui_Media_Video_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vídeo do exercício: ${i?.name}`)
};

const es_419_ui_media_video_label = /** @type {(inputs: Ui_Media_Video_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Video del ejercicio: ${i?.name}`)
};

const pt_pt2_ui_media_video_label = /** @type {(inputs: Ui_Media_Video_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vídeo do exercício: ${i?.name}`)
};

const fr_fr2_ui_media_video_label = /** @type {(inputs: Ui_Media_Video_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vidéo de l'exercice : ${i?.name}`)
};

const de_de2_ui_media_video_label = /** @type {(inputs: Ui_Media_Video_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Übungsvideo: ${i?.name}`)
};

const it_it2_ui_media_video_label = /** @type {(inputs: Ui_Media_Video_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Video dell'esercizio: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "{name}, exercise video" |
*
* @param {Ui_Media_Video_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_media_video_label = /** @type {((inputs: Ui_Media_Video_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Media_Video_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_media_video_label(inputs)
	if (locale === "es-419") return es_419_ui_media_video_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_media_video_label(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_media_video_label(inputs)
	if (locale === "de-DE") return de_de2_ui_media_video_label(inputs)
	if (locale === "it-IT") return it_it2_ui_media_video_label(inputs)
	return en_us2_ui_media_video_label(inputs)
});
export { ui_media_video_label as "ui-media.video_label" }